import React, {Component} from "react";
import {Form, Input , Radio} from 'antd';
import NHFormItem from '../../../common/NHFormItem';
import NHSelect from '../../../common/NHSelect';

const FormItem = Form.Item;

const baseUrlPath = "/wbdStudentMng"; //基础路径

/**
 * 未报到学生管理编辑表单
 * @author Xiafanglin
 * @date 2018-03-12 02:44:45
 * Version: 1.0
 */
class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }


    render() {

        const {getFieldDecorator,setFieldsValue} = this.props.form;
        const initFormData = this.props.initFormData;
        const { getFieldProps } = this.props.form;
        return (
            <div>
                <Form layout="horizontal">
                    <div style={{display:'none'}} >
                        <NHFormItem label="主键" id={"xsid"}
                                    form={this.props.form}  initialValue={initFormData.XSID}>
                            <Input  />
                        </NHFormItem>
                        <NHFormItem label="年度" id={"nd"}
                                    form={this.props.form}  initialValue={initFormData.ND}>
                            <Input  />
                        </NHFormItem>
                    </div>
                    <NHFormItem id={"wbdyydm"} required={true} label={"未报到原因"}
                                form={this.props.form} initialValue={initFormData.WBDYYDM}>
                        <NHSelect sign={"DMK_YXXT_WBDYY"} style={{width:"100%"}} />
                    </NHFormItem>
                    <NHFormItem id={"bz"} label={"备注"}
                                form={this.props.form} initialValue={initFormData.BZ}>
                        <textarea class="ant-input" type="textarea"></textarea>
                    </NHFormItem>
                </Form>
            </div>
        );
    }
}

const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/tjcx/queryStudents/scjtQueryStudents/EditForm.js